import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ArticuloTransferencia, ArticuloTransferenciaTipo } from "@/shared/types/articulo-transferencia";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ArticuloTransferenciaRequest {
    fecha?: string;
    tipo:ArticuloTransferenciaTipo,
    depositoOrigenId: string,
    depositoDestinoId: string,
    items: ArticuloTransferenciaItemRequest[]
}

export interface ArticuloTransferenciaItemRequest {
    articuloId: string;
    cantidad: number;
}

export async function addArticuloTransferencia(request: ArticuloTransferenciaRequest): Promise<ArticuloTransferencia> {
    await sleep(1000);
    const response = await api.post("articulo_transferencias", request);
    return response.data;
}

export function useAddArticuloTransferenciaMutation(mutationConfig: MutationConfig<ArticuloTransferencia, ArticuloTransferenciaRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addArticuloTransferencia,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulo_transferencias"] });
        },
    })
}

export interface AddArticuloTransferenciaMutationProps {
    mutationConfig?: MutationConfig<ArticuloTransferencia, ArticuloTransferenciaRequest>
    children?: (mutationResult: MutationResult<ArticuloTransferencia, ArticuloTransferenciaRequest>) => ReactNode
}

export function AddArticuloTransferenciaMutation({
    mutationConfig,
    children
}: AddArticuloTransferenciaMutationProps) {
    const mutationResult = useAddArticuloTransferenciaMutation(mutationConfig);
    return children && children(mutationResult);
}